import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Autosuggest from "react-autosuggest";

/**
 * Recherche de client (commanditaire) pour la qualification d'un événement B2B.
 * Calque le comportement de CustomerSelectComponent (éditeur de devis) mais en
 * mode contrôlé : ne touche pas au brouillon de devis (orderEdition) et remonte
 * le client sélectionné au parent via onSelect.
 */
const EvenementClientSelect = ({ value = "", onSelect }) => {
  const customers = useSelector((state) =>
    state.adminData.customers ? state.adminData.customers : []
  );

  const [inputValue, setInputValue] = useState(value || "");
  const [suggestions, setSuggestions] = useState([]);

  useEffect(() => {
    setInputValue(value || "");
  }, [value]);

  const getSuggestions = (val) => {
    const input = (val || "").trim().toLowerCase();
    if (input.length === 0) {
      return [];
    }
    return customers
      .filter(
        (c) =>
          `${c.lastname || ""}`.toLowerCase().includes(input) ||
          `${c.firstname || ""}`.toLowerCase().includes(input) ||
          `${c.email || ""}`.toLowerCase().includes(input)
      )
      .slice(0, 12);
  };

  const theme = {
    input: {
      display: "block",
      width: "100%",
      height: "calc(1.5em + .75rem + 2px)",
      padding: ".375rem .75rem",
      fontSize: "1rem",
      lineHeight: "1.5",
      color: "#495057",
      backgroundColor: "#fff",
      backgroundClip: "padding-box",
      border: "1px solid #ced4da",
      borderRadius: ".25rem",
    },
  };

  return (
    <Autosuggest
      suggestions={suggestions}
      onSuggestionsFetchRequested={({ value: v }) => setSuggestions(getSuggestions(v))}
      onSuggestionsClearRequested={() => setSuggestions([])}
      getSuggestionValue={(s) => `${s.lastname || ""} ${s.firstname || ""}`.trim()}
      renderSuggestion={(s) => (
        <div>{`${s.lastname || ""} ${s.firstname || ""} ${s.email ? `— ${s.email}` : ""} (ID ${s.id})`}</div>
      )}
      inputProps={{
        placeholder: "Recherche d'un client…",
        value: inputValue,
        onChange: (event, { newValue }) => setInputValue(newValue),
      }}
      onSuggestionSelected={(event, { suggestion }) => onSelect && onSelect(suggestion)}
      theme={theme}
    />
  );
};

export default EvenementClientSelect;
